import React from 'react';
import { testimonials } from '../mock';
import { Star } from '@phosphor-icons/react';
import { Card } from './ui/card';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const TestimonialsSection = () => {
  const [emblaRef] = useEmblaCarousel({
    loop: true, align: 'start', slidesToScroll: 1, duration: 45
  }, [Autoplay({ delay: 3500, stopOnInteraction: false })]);

  return (
    <section data-testid="testimonials-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          {/* <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#044B3B] mb-3">
            Protecting Brands Across Industries
          </p> */}
          <h2 className="text-3xl sm:text-4xl font-heading font-medium text-slate-900 tracking-tight mb-4">
            Protecting Brands Across Industries
          </h2>
          <p className="text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Businesses, startups, and growing brands trust our trademark registration services to help secure their names, logos, and valuable intellectual property. Discover why entrepreneurs and business owners choose our team for reliable brand protection and long term trademark support.
          </p>
        </div>

        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-5">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className={`flex-[0_0_100%] md:flex-[0_0_calc(50%-10px)] lg:flex-[0_0_calc(33.333%-14px)] min-w-0 ${testimonial.id === 5 ? 'mr-5' : ''}`}>
                <Card data-testid={`testimonial-${testimonial.id}`} className="p-8 h-full border border-slate-200 rounded-md hover:border-[#044B3B]/20 transition-colors">
                  <div className="flex gap-0.5 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 text-[#D4AF37]" weight="fill" />
                    ))}
                  </div>
                  <p className="text-sm text-slate-600 mb-6 leading-relaxed italic">
                    &ldquo;{testimonial.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-100">
                    <img src={testimonial.image} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover" />
                    <div>
                      <h4 className="text-sm font-semibold text-slate-900">{testimonial.name}</h4>
                      <p className="text-xs text-slate-500">{testimonial.role}</p>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
